import WrenchIcon from '@svg/wrench.svg?react';
import './connection-name-cell.scss';
import { IconWithTooltip } from '../connection-policy-info-cell/icon-with-tooltip';
import { ConnectionModel } from '../../connection.model';

const ConnectionNameCell: React.FC<{ connection: ConnectionModel }> = ({ connection }) => {
    const hasNickName = !!connection.connectionName && connection.connectionName !== connection.circuitId;

    return (
        <div className={'connection-name-cell'}>
            {!connection.isAvailable && (
                <IconWithTooltip
                    tooltipClassName="maintenance-tooltip"
                    iconClassName="wrench-icon"
                    title="Connection is currently under maintenance"
                    IconComponent={WrenchIcon}
                />
            )}
            <div className={'connection-name-wrapper'}>
                <span className={'connection-name-primary'}>
                    {hasNickName ? connection.connectionName : connection.circuitId}
                </span>
                <div className="connection-name-secondary">
                    {hasNickName && <span className="connection-circuit-id">{connection.circuitId}</span>}
                </div>
            </div>
        </div>
    );
};

export default ConnectionNameCell;